import SearchComponent from '../base/search-component.ts';
import type { LavoratoreCompleto } from '@/types/entities/ricerca.ts';

interface RisultatoRicerca {
  risultati: LavoratoreCompleto[];
  count: number;
}

const MODE_SELEZIONA = 'seleziona';

export class RicercaLavoratori extends SearchComponent<RisultatoRicerca> {
  static override componentName = 'wc-ricerca-lavoratori';

  private risultati: LavoratoreCompleto[] = [];

  protected override get templateId() { return 'ricerca-lavoratori'; }
  protected override get resultsTemplateId() { return 'shared-lavoratori-risultati'; }

  private get modalitaSelezione(): boolean {
    return this.attributeString('mode') === MODE_SELEZIONA;
  }

  protected override fetchResults(query: string) {
    return this.api.lavoratori.cerca(query);
  }

  protected override mapResultsData(data: RisultatoRicerca) {
    this.risultati = data.risultati;
    const action = this.modalitaSelezione ? 'seleziona-lavoratore' : 'dettaglio';
    return { lavoratori: data.risultati, count: data.count, action };
  }

  protected override onReady(): void {
    const basePath = this.attributeString('detail-path', '/lavoratori');

    this.delegate.on<MouseEvent>('click', '[data-action="dettaglio"]', (e) => {
      const id = (e.target as HTMLElement).dataset.id;
      if (id) window.location.href = `${basePath}/${id}`;
    });

    this.delegate.on<MouseEvent>('click', '[data-action="seleziona-lavoratore"]', (e) => {
      const id = Number((e.target as HTMLElement).dataset.id);
      const lavoratore = this.risultati.find((l) => l.id === id);
      if (lavoratore) this.dispatch('lavoratore-selezionato', lavoratore);
    });
  }
}
